import { useState, useEffect } from "react";
import { Card, Tabs, Tab, Box } from "@mui/material";

import LinkIcon from "@mui/icons-material/Link";
import GamepadIcon from "@mui/icons-material/Gamepad";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CloudIcon from "@mui/icons-material/Cloud";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PersonIcon from "@mui/icons-material/Person";

import OrganizationActionsTab from "./tabs/actions";
import OrganizationPersonsTab from "./tabs/persons";
import OrganizationFiscalTab from "./tabs/fiscal";
import OrganizationContabilTab from "./tabs/contabil";
import OrganizationDpTab from "./tabs/dp";
import OrganizationCloudTab from "./tabs/cloud";
import SaveRHTab from "./tabs/saveRH";
import SaveFinancTab from "./tabs/saveFinanc";
import PersonaTab from "./tabs/persona";

import { useOrganization } from ".";

export function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const TabsCard = () => {
  const [value, setValue] = useState(0);
  const organization = useOrganization();
  const { data } = organization;

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization.data._id]);

  const getTabs = () => {
    const tabs = [
      {
        label: "Ações",
        icon: <GamepadIcon />,
        component: <OrganizationActionsTab />,
      },
      {
        label: "Contatos",
        icon: <GroupIcon />,
        component: <OrganizationPersonsTab />,
      },
      {
        label: "Arquivos",
        icon: <CloudIcon />,
        component: <OrganizationCloudTab />,
      },
      {
        label: "Fiscal",
        icon: <ReceiptLongIcon />,
        component: <OrganizationFiscalTab />,
      },
      {
        label: "Contábil",
        icon: <MonetizationOnIcon />,
        component: <OrganizationContabilTab />,
      },
      {
        label: "DP",
        icon: <AssignmentIndIcon />,
        component: <OrganizationDpTab />,
      },
    ];

    if (data?.products?.saveRH?.active) {
      tabs.push({
        label: "SAVE RH",
        icon: <PeopleIcon />,
        component: <SaveRHTab />,
      });
    }

    if (data?.products?.saveFinanc?.active) {
      tabs.push({
        label: "SAVE Financ",
        icon: <AccountBalanceIcon />,
        component: <SaveFinancTab />,
      });
    }

    if (data?.products?.persona?.active) {
      tabs.push({
        label: "Persona",
        icon: <PersonIcon />,
        component: <PersonaTab />,
      });
    }

    return tabs;
  };

  const tabs = getTabs();

  return (
    <Card>
      <Box
        sx={{
          borderRadius: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-scrollButtons": {
              color: "primary.main",
              "&.Mui-disabled": {
                opacity: 0.3,
              },
            },
            "& .MuiTabs-scroller": {
              "&::-webkit-scrollbar": {
                height: 4,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: 2,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "primary.main",
                borderRadius: 2,
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              },
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              iconPosition="start"
              sx={{ minHeight: 50 }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <TabPanel
          key={index}
          value={value}
          index={index}
          sx={index === 0 ? { p: 0 } : {}}
        >
          {tab.component}
        </TabPanel>
      ))}
    </Card>
  );
};

export default TabsCard;
